import {Box, Typography} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid-pro';
import {FCFileGridItem} from '../../../../../types/upload-new-eviidence/fcUploadFileTypes';
import {FC_FILE_TRANSFER_ROW_HEIGHT} from '../../../../../utils/fcUploadFileUtils';
import {isEmptyInstance} from '../../../../../utils/utils';
import AurDataGridPro from '../../../../common/aur-data-grid-pro/AurDataGridPro';

export interface FCUploadDataGridProps {
  sectionTitle: string;
  noDataText: string;
  fileGridItemArray: FCFileGridItem[];
  dataGridColumnConfig: GridColDef<FCFileGridItem>[];
}

const FCUploadDataGrid: React.FC<FCUploadDataGridProps> = ({
  sectionTitle,
  noDataText,
  fileGridItemArray,
  dataGridColumnConfig,
}) => {
  const renderNoFileList = (title: string) => {
    return (
      <Box className={'no-files-list-container'}>
        <Typography
          className="typo-text body1_size subtitle-text-color"
          tabIndex={0}
        >
          {`${title}`}
        </Typography>
      </Box>
    );
  };

  return (
    <Box className={'fc-upload-data-grid-container'}>
      <Typography className="typo-text subhead2_size text-color" tabIndex={0}>
        {sectionTitle}
      </Typography>
      {isEmptyInstance(fileGridItemArray) ? (
        renderNoFileList(noDataText)
      ) : (
        <AurDataGridPro
          getRowId={(row) => row?.id}
          rows={fileGridItemArray}
          hideSortIcons={true}
          className={'file-transfer-datagrid'}
          columns={dataGridColumnConfig}
          disableColumnSorting={false}
          checkBoxVisible={false}
          hideFooter
          getRowHeight={() => FC_FILE_TRANSFER_ROW_HEIGHT}
          hideFooterRowCount
          disableVirtualization
          hideFooterSelectedRowCount
          disableRowSelectionOnClick
          autoPageSize
          autoHeight
        />
      )}
    </Box>
  );
};

export default FCUploadDataGrid;
